import React, { useState, useEffect, useContext } from "react";
import {
  getProducts,
  getSuppliers,
  getBrand,
  getManufacturers,
  addInventoryOrder,
  getWarehouseProduct,
  getWarehouses,
  getPurchaseOrder,
} from "../../../Utility/Api"; // Remove getProducts and getUsers if you're using dummy data
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { WarehouseContext } from '../../../Utility/UserContext';

const PurchaseInventory = () => {
  const location = useLocation();
  const { state } = location;
  const [products, setProducts] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [SupplierId, setSupplierId] = useState(0);
  const [Brand, setBrand] = useState([]);
  const [Manufacturers, setManufacturers] = useState([]);

  const [warehouses, setWarehouses] = useState([]);
  const { showLoader, hideLoader, UserItem } = useContext(WarehouseContext);
  const [AuthUser, setAuthUser] = useState(UserItem);
  useEffect(() => {
    if (state) {
      getPurchaseOrderData(state);
    }
    fetchProducts();
    fetchBrand();
    fetchSuppliers();
    fetchWarehouse();
    fetchManufacturers();
  }, []);

  const getPurchaseOrderData = async (Purchase) => {
    var res = await getPurchaseOrder(Purchase.po);
    setSupplierId(res.data.data[0].supplier_id);
    const formattedData = res.data.data.map((item) => ({
      id: item.id || "",
      product_id: item.product_id || "",
      manufacturer_id: item.manufacturer_id || "",
      brands_id: item.brands_id || "",
      qty: item.qty || "",
      supplier_id: item.supplier_id || "",
      warehouse_id: item.warehouse_id || "", // You can set a default value or add it dynamically
    }));

    // Update the state with the new data
    setRows(formattedData);
  };

  const fetchBrand = async () => {
    try {
      const response = await getBrand();
      if (response.data && response.data.data) {
        setBrand(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const fetchWarehouse = async () => {
    try {
      const response = await getWarehouses();
      if (response.data && response.data.data) {
        setWarehouses(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
      toast.error("Error fetching warehouses");
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await getManufacturers();
      if (response.data && response.data.data) {
        setManufacturers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await getProducts();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) { }
  };

  const fetchWarehouseBasedProduct = async (id) => {
    try {
      const response = await getWarehouseProduct(id);
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [rows, setRows] = useState([
    {
      id: 1,
      product_id: "",
      manufacturer_id: "",
      brands_id: "",
      qty: "",
      supplier_id: "",
      warehouse_id: "",
      purchase_price: "",
      sales_price: "",
      bulk_price: "",
    },
  ]);

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1,
      product_id: "",
      supplier_id: "",
      manufacturer_id: "",
      brands_id: "",
      qty: "",
      purchase_price: "",
      sales_price: "",
      bulk_price: "",
    };
    setRows([...rows, newRow]);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = rows.map((row, rowIndex) =>
      rowIndex === index ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
    if (field == "warehouse_id") {
      fetchWarehouseBasedProduct(value);
    }
  };

  const HandleSubmit = async () => {
    showLoader()
    try {
      const saveObject = {
        user_id: AuthUser?.id,
        supplier_id: SupplierId,
        data: rows,
      };
      const Data = await addInventoryOrder(state.po, saveObject);
      hideLoader()
      toast.success("Purchase Order added successfully");
      if (Data) {
        window.location.href = "/purchase";
      }
    } catch (error) {
      console.error("Error saving Purchase Order data:", error);
      hideLoader()
      toast.error("Error saving Order");
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <div className="row">
          <div className="col-6">
            From&nbsp;
            {AuthUser?.full_name}
          </div>
          <div className="col-6 mx-end text-end">
            {new Date().toLocaleDateString("en-GB")}
          </div>
        </div>
        <div className="container mt-5 px-2">
          <div className="row">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-6">
                    {/* <button className="btn btn-primary btn-sm m-2  text-normal rounded-1"
                                        onClick={HandleSubmit}
                                        >Submit</button> */}
                  </div>
                  {/* <div className='col-6 text-end'>
                                           <img src="/assets/images/icons/add.png"
                                                        className='m-1'
                                                        onClick={handleAddRow}
                                                        width={"20px"}/>
                                    </div> */}
                </div>
                {/* <select
                                    name="supplier_id"
                                    className="p-0"
                                    value={SupplierId}
                                    onChange={(e) => setSupplierId(e.target.value)}
                                >
                                    <option value="">Select Supplier</option>
                                    {supplier.map((suply) => (
                                        <option key={suply.supplier_id} value={suply.supplier_id}>
                                            {suply.supplier_name}
                                        </option>
                                    ))}
                                </select> */}

                {/* <div className='row'>
                                <div className="form-group col-6 mb-3 d-flex align-items-center">
                                                <label className="col-3 text-normal">Supplier</label>
                                                <select
                                                name="supplier_id"
                                                value={SupplierId}
                                                onChange={(e) => setSupplierId(e.target.value)}
                                                className="form-control text-normal"
                                                required
                                                >
                                                <option value="">Select Supplier</option>
                                                {supplier.map((suply) => (
                                        <option key={suply.supplier_id} value={suply.supplier_id}>
                                            {suply.supplier_name}
                                        </option>
                                    ))}
                                                </select>
                                            </div>
                                            </div> */}
                <div className="table-responsive">
                  <table
                    id="example"
                    className="table table-sm table-striped table-bordered"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Product</th>
                        <th>Manufacturer</th>
                        <th>brands</th>
                        <th>Quantity</th>
                        <th>Purchase Price</th>
                        <th>Sales Price</th>
                        <th>Bulk Price</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          {/* <td>
                                                        <select name="warehouse_id"
                                                            className="p-0"
                                                            value={row.warehouse_id}
                                                            onChange={(e) => {handleInputChange(index, "warehouse_id", e.target.value)}}
                                                            required disabled={true}>
                                                            <option value="">Select Warehouse</option>
                                                            {warehouses.map((pro) => (
                                                                <option key={pro.id} value={pro.id}>
                                                                    {pro.title}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td> */}
                          <td>
                            <select
                              name="product_id"
                              className="p-0"
                              value={row.product_id}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "product_id",
                                  e.target.value
                                )
                              }
                              required
                              disabled={true}
                            >
                              <option value="">Select Product</option>
                              {products.filter(item => item.status != 2).map((pro) => (
                                <option key={pro.id} value={pro.product_id}>
                                  {pro.product_name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              name="manufacturer_id"
                              className="p-0"
                              value={row.manufacturer_id}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "manufacturer_id",
                                  e.target.value
                                )
                              }
                              required
                              disabled={true}
                            >
                              <option value="">Select Manufacturer</option>
                              {Manufacturers.map((Manu) => (
                                <option
                                  key={Manu.manufacturer_id}
                                  value={Manu.manufacturer_id}
                                >
                                  {Manu.name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              name="brands_id"
                              className="p-0"
                              value={row.brands_id}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "brands_id",
                                  e.target.value
                                )
                              }
                              required
                              disabled={true}
                            >
                              <option value="">Select Brand</option>
                              {Brand.map((cat) => (
                                <option key={cat.brand_id} value={cat.brand_id}>
                                  {cat.name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input
                              type="qty"
                              className="p-0 w-100"
                              value={row.qty}
                              disabled={true}
                              onChange={(e) =>
                                handleInputChange(index, "qty", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="p-0 w-100"
                              value={row.purchase_price}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "purchase_price",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="p-0 w-100"
                              value={row.sales_price}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "sales_price",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="p-0 w-100"
                              value={row.bulk_price}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "bulk_price",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          {/* <td>
                                                        <img src="/assets/images/icons/delete.png"
                                                        className='m-1'
                                                        onClick={() => handleRemoveRow(index)}
                                                        width={"20px"}/>
                                                    </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="w-100 d-flex justify-content-end">
                  <button
                    className="btn btn-primary btn-sm m-2  text-normal rounded-1"
                    onClick={HandleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseInventory;
